export const getPath = (x1,y1,x2,y2) => {
    let d = Math.sqrt(dist(x1,y1,x2,y2)) * window.dist;
    let yDistance = Math.abs(y2-y1);
    let xd = Math.abs(x2 - x1);
    let xDistance = Math.sqrt(xd);
    if (x2 - x1 < 0) {
        xDistance *= -1;
    }
    if (xd < 20) {
        xDistance += (20 - xd);
    }
 
    return [x1, y1, x1 + window.x*xDistance, y1+d, x2 - window.x*xDistance, y2-d, x2, y2];
};

const dist = (x1, y1, x2, y2) => {
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
};
